<template>
  <header class="sticky top-0 z-[900] flex min-h-16 items-center gap-3 border-b border-slate-300/30 bg-white/90 px-7 py-3 backdrop-blur max-md:px-3.5 max-md:py-2.5">
    <button type="button" class="hidden h-10 w-10 items-center justify-center rounded-lg border border-slate-300 bg-white text-slate-700 max-md:inline-flex" @click="$emit('toggleSidebar')">
      <span class="pi pi-bars"></span>
    </button>

    <div class="flex min-h-[38px] items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-[13px] text-[13px] font-bold text-slate-700">
      <span class="pi pi-clock mr-2" />
      <span>{{ nowText }}</span>
    </div>

    <div class="flex-1"></div>

    <div class="flex min-h-[42px] items-center gap-2.5 rounded-full border border-slate-200 bg-white py-[3px] pl-[3px] pr-[13px] shadow-[0_8px_22px_rgba(15,23,42,0.06)]">
      <div class="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-teal-700 to-cyan-800 font-extrabold text-white" :title="roleLabel">
        {{ avatarText }}
      </div>
      <div class="flex flex-col leading-none">
        <div class="whitespace-nowrap text-xs font-extrabold text-slate-700">{{ roleLabel }}</div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";

export default {
  name: "AppHeader",
  props: {
    role: {
      type: String,
      required: true,
    },
  },
  emits: ["toggleSidebar"],
  setup(props) {
    const now = ref(new Date());
    let timer: number | undefined;

    const roleLabel = computed(() => {
      switch ((props.role || "").toLowerCase()) {
        case "admin":
          return "Quản trị (Admin)";
        case "ward":
          return "Phường";
        case "district":
          return "Quận/Huyện";
        case "civilgroup":
          return "Tổ dân phố";
        default:
          return props.role ? `Vai trò: ${props.role}` : "Chưa xác định vai trò";
      }
    });

    const avatarText = computed(() => {
      // Lấy chữ cái đầu của role label để làm avatar fallback
      const raw = roleLabel.value.replace("Quản trị (Admin)", "Admin");
      const ch = raw.trim().charAt(0).toUpperCase();
      return ch || "U";
    });

    const nowText = computed(() => {
      const d = now.value;
      const pad = (n: number) => String(n).padStart(2, "0");
      const day = pad(d.getDate());
      const month = pad(d.getMonth() + 1);
      const year = d.getFullYear();
      const hh = pad(d.getHours());
      const mm = pad(d.getMinutes());
      const ss = pad(d.getSeconds());
      return `${day}/${month}/${year} ${hh}:${mm}:${ss}`;
    });

    onMounted(() => {
      timer = window.setInterval(() => {
        now.value = new Date();
      }, 1000);
    });

    onBeforeUnmount(() => {
      if (timer) window.clearInterval(timer);
    });

    return { roleLabel, avatarText, nowText };
  },
};
</script>
`r`n
